module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_footer_image_02-bd74ee7c4f24b2bfd2f77b304911f098.jpg";